import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SyncUserSettingsService } from '@frontend/sports/user/feature';
import { Decimal } from 'decimal.js';

import { IBetslipSummary } from '../../summary/models';
import { ITaxationInfoViewModel } from '../../taxation/components/digital/taxation-info.component';

@Component({
    selector: 'bs-turnover-tax',
    templateUrl: './turnover-tax.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./turnover-tax.component.scss'],
    standalone: false,
})
export class TurnoverTaxComponent {
    @Input() betslipSummary: IBetslipSummary;
    isTaxationInfoVisible = false;

    constructor(
        private userSettings: SyncUserSettingsService,
        private sitecore: Sitecore,
        private changeDetector: ChangeDetectorRef,
    ) {}

    displayTaxationInfo(): void {
        this.isTaxationInfoVisible = true;
        this.changeDetector.markForCheck();
    }

    get taxInfoMessage(): string {
        return this.betslipSummary?.taxation?.rate?.greaterThan(0)
            ? this.sitecore.betslip.messages.TurnoverAndWinningTax
            : this.sitecore.betslip.messages.TurnoverTax;
    }

    get isTurnoverTax(): boolean {
        return this.userSettings.isTurnoverTaxApplied;
    }

    get getTaxationViewModel(): ITaxationInfoViewModel {
        if (!this.betslipSummary?.taxation?.rate) {
            return {
                possibleWinningsGross: null,
                possibleWinningsNet: null,
                taxationAmount: null,
                taxationRate: null,
            };
        }

        return {
            possibleWinningsGross: this.betslipSummary.possibleWinnings || new Decimal(0),
            possibleWinningsNet: this.betslipSummary.possibleWinningsNet || new Decimal(0),
            taxationAmount: this.betslipSummary.taxation?.amount || null,
            taxationRate: this.betslipSummary.taxation?.rate || null,
        };
    }
}
